// extracted by mini-css-extract-plugin
module.exports = {"text":"navigation-new_text_3jJ","hidden":"navigation-new_hidden_3RG","root":"navigation-new_root_1uC"};